export default {"src":"/_next/static/media/readySite4.48f6a684.svg","height":192,"width":220,"blurWidth":0,"blurHeight":0};